import { ECategory } from '@pkg/lib-data'
import type { IShowCatalog, IShowCatalogProduct } from '@pkg/lib-data'

/**
 * Transforms catalog data from SEO format (array of products) to widget format (IShowCatalog)
 * This allows the widget to use the same catalog structure it expects
 */
export const transformCatalogForWidget = (products: IShowCatalogProduct[]): IShowCatalog => {
  // Group products by their properties to create a single catalog entry
  // The widget expects IShowCatalog format with products and promotedProducts
  const catalogProducts: Record<string, IShowCatalogProduct> = {}
  const promotedProducts: Record<string, IShowCatalogProduct> = {}

  for (const product of products) {
    if (product.isPromoted) {
      promotedProducts[product.id] = product
    } else {
      catalogProducts[product.id] = product
    }
  }

  // Create a single catalog entry
  const catalog: IShowCatalog = {
    catalogCategoryType: ECategory.SHOWS,
    products: catalogProducts,
    promotedProducts,
  }

  return catalog
}

/**
 * Converts IShowCatalog to array format for widget transforms
 * The widget's transform functions expect IShowCatalog[] (array of catalogs)
 */
export const catalogToArray = (catalog: IShowCatalog): IShowCatalog[] => {
  return [catalog]
}
